import { render, staticRenderFns } from "./ContentSlideTemplateCategories.vue?vue&type=template&id=88daf6a2&scoped=true&"
import script from "./ContentSlideTemplateCategories.vue?vue&type=script&lang=js&"
export * from "./ContentSlideTemplateCategories.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlideTemplateCategories.vue?vue&type=style&index=0&id=88daf6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88daf6a2",
  null
  
)

export default component.exports